import React from "react";
import { useTranslation } from "react-i18next";
import "./Stars.css"; // Optional for custom star styles

function Stars({ rating }) {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const fullStars = Math.floor(rating);
  const decimal = rating - fullStars;
  const showHalf = decimal >= 0.25 && decimal < 0.75;
  const remaining = 5 - fullStars - (showHalf ? 1 : 0);

  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <span key={`full-${i}`} className="star full">
        ★
      </span>
    );
  }

  if (showHalf) {
    stars.push(
      <span
        key="half"
        className={`star half ${i18n.dir() === "rtl" ? "rtl" : ""}`}
      >
        ★
      </span>
    );
  }

  for (let i = 0; i < remaining; i++) {
    stars.push(
      <span key={`empty-${i}`} className="star empty">
        ★
      </span>
    );
  }

  return <div className="rating-stars">{stars}</div>;
}

export default Stars;
